import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ReviewPopupKYC from './review-popup';
import DocumentPreview from '../../Pages/Create-Investment/documentpreview';
import ActivityLog from '../../Components/ActivityLog/activity-log';
import { useSelector } from 'react-redux';
import StatusButton from '../../Components/Onbaording/status-button';
import FileUploadDisplay from '../../Components/Onbaording/file-display';
import MindmapTree from '../../Components/Onbaording/onboarding-tree';
import { useToast } from '../../Utils/toastContext';
import SectionStatusGrid from '../../Components/Onbaording/status-section';
import { debounce } from 'lodash';
import TrusteesPanel from '../../Components/onboarding/trustee-panel';
import UserQuestionnaire from '../../Pages/Risk-Assessment/user-questionnarie';
// import StatusDropdown from "../../Components/Onbaording/section-status-dropdown";
import EDDModal from '../../Pages/Risk-Assessment/edd-modal';
import AuditStepper from '../../Components/Onbaording/onboarding-stepper';

// const steps = [
//   {
//     key: 'submitted',
//     label: 'Application Submitted',
//     icon: 'description',
//     status: 'completed',
//   },
//   // {
//   //   key: 'sanction',
//   //   label: 'Sanction Verified',
//   //   icon: 'gavel',
//   //   status: 'completed',
//   // },
//   {
//     key: 'identity',
//     label: 'Identity Verified',
//     icon: 'verified_user',
//     status: 'completed',
//   },
//   {
//     key: 'manual',
//     label: 'Manual Review',
//     icon: 'manage_search',
//     status: 'active',
//   },
//   {
//     key: 'approved',
//     label: 'Approved',
//     icon: 'check_circle',
//     status: 'pending',
//   },
// ];
const ReviewKYCTrust = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dropdownRef = useRef();
  const navigate = useNavigate();
  const { customerId } = useParams();
  const [customerStatus, setCustomerStatus] = useState(null);
  const roleName = useSelector((state) => state.user.roleName);
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [eddResponse, setEddResponse] = useState(null);
  const [sanctionResults, setSanctionResults] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [fileAccountantCertificate, setFileAccountantCertificate] =
    useState(null);
  const [steps, setSteps] = useState([]);

  const [countryType, setCountryType] = useState(1);
  const [registrationNumber, setRegistrationNumber] = useState('');
  const [trustType, setTrustType] = useState('Bare');
  const [fullSettlorName, setFullSettlorName] = useState('');
  const [assets, setAssets] = useState([]);
  const [trusteeResponse, setTrusteeResponse] = useState(null);
  const updateFieldStatus = useSelector(
    (state) => state.form.updateFieldStatus,
  );
  const [fileProof, setFileProof] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [loading, setLoading] = useState(false);
  const [layers, setLayers] = useState([]);
  const [mobileNumber, setMobileNumber] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [lastNameSignup, setLastNameSignup] = useState('');
  const [firstNameSignup, setFirstNameSignup] = useState('');
  const [email, setEmail] = useState('');
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [abn, setAbn] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [registeredAddress, setRegisteredAddress] = useState('');
  const [fileAmlProgram, setFileAmlProgram] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [hasAml, setHasAml] = useState({
    verification_id: null,
    value: false,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileProspectusDocument, setFileProspectusDocument] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileSelfManagedExtract, setFileSelfManagedExtract] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileTrustDeed, setFileTrustDeed] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileGovFund, setFileGovFund] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileRegisteredSubject, setFileRegisteredSubject] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileScheme, setFileScheme] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [countryId, setCountryId] = useState(4);
  const [companycategoryId, setCompanycategoryId] = useState(3);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }
  const [isOpenAction, setIsOpenAction] = useState(false);
  const [businessActivity, setBusinessActivity] = useState('smaple text');
  const [otherActivity, setOtherActivity] = useState('');
  const [preview, setPreview] = useState('');

  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  const latest = sanctionResults?.latest;

  const fullNameSanction = latest?.request_payload?.full_name || '-';
  const screeningDate = latest?.response_timestamp || '-';

  const uiMessage = latest?.ui?.message;
  const uiSummary = latest?.ui?.summary;
  const sourcesChecked =
    latest?.response_payload?.data?.evidence?.sources_checked || [];

  const matchedSources = latest?.matched_sources || [];
  const decision = latest?.decision || {};
  const getSourceStyle = (source, isMatched) => {
    if (isMatched) {
      return 'bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200';
    }

    return 'bg-blue-50 text-blue-600 border-blue-200';
  };
  const formatSourceName = (source) => {
    return source
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [accountTypeLabel, setAccountTypeLabel] = useState('Individual');
  const [fullName, setFullName] = useState('John Mayer');
  const [formerNames, setFormerNames] = useState('John Mayer');
  const [fileExtractDocument, setFileExtractDocument] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const pendingQuestions = mapQuestions(
    (eddResponse?.pending || []).flatMap((item) => item.questions || []),
  );

  const completedQuestions = mapQuestions(
    (eddResponse?.completed || []).flatMap((item) => item.questions || []),
  );
  const completedGroups = (eddResponse?.completed || []).map((item) => ({
    id: item.id,
    requestedBy: item.requested_by?.name,
    respondedAt: item.responded_at,
    questions: mapQuestions(item.questions || []),
  }));
  const { showToast } = useToast();
  const [statusData, setStatusData] = useState([]);
  const getStatusSanction = (val) => (val ? 'found' : 'completed');

  const sanctionsStatus = getStatusSanction(decision?.sanctions);
  const pepStatus = getStatusSanction(decision?.pep);
  const adverseStatus = getStatusSanction(decision?.adverse_media);
  const getComplianceStatus = () => {
    if (!decision) return { label: '-', color: 'text-gray-500', sub: '' };

    if (!decision.pep && !decision.sanctions && !decision.adverse_media) {
      return {
        label: 'Clear',
        color: 'text-green-600',
        sub: uiMessage || 'No risk detected',
      };
    }

    if (decision.sanctions) {
      return {
        label: 'High Risk',
        color: 'text-red-600',
        sub: 'Sanctions match found',
      };
    }

    return {
      label: 'Review Required',
      color: 'text-amber-600',
      sub: 'Further checks recommended',
    };
  };
  const compliance = getComplianceStatus();
  // const handleUpdateSection = useCallback(
  //   debounce(async (action, sectionId) => {
  //     let toastMessage = null;
  //     try {
  //       const response = await updateSection(action, sectionId);
  //       if (response.status == 200) {
  //         toastMessage = {
  //           message: response.message,
  //           type: "success",
  //         };
  //         getStatus();
  //         getAllDetails();
  //       } else {
  //         toastMessage = { message: response.message, type: "error" };
  //       }
  //     } catch (error) {
  //       toastMessage = { message: error.message, type: "error" };
  //     } finally {
  //       setLoadingUpdate(false); // Ensure `loading` is false first
  //       // Show toast after loading is false
  //       if (toastMessage) {
  //         setTimeout(() => {
  //           showToast(toastMessage.message, toastMessage.type);
  //         }, 1000); // Small delay if needed
  //       }
  //     }
  //   }, 1000),
  //   [customerId], // Dependencies
  // );

  const updateApplication = async (action) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      roleName == 'agent'
        ? action == 'approve'
          ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agent/customers/review/${customerId}/reject`
        : action == 'approve'
          ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agency/customers/review/${customerId}/reject`;
    const bodyData = {
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };

          if (roleName == 'compliance_officer') {
            navigate('/customer-list', { state: { componentName: 'agency' } });
          } else {
            navigate('/customer-list');
          }
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  // Recursively build nodes & edges from API data
  const [showVisualLink, setShowVisualLink] = useState(false);
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = true; // collapsed
    });
    setCollapsedLayers(newState);
  };

  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = false; // expanded
    });
    setCollapsedLayers(newState);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const mapApiLayersToUiLayers = (apiLayers = []) => {
    return apiLayers.map((layer) => {
      const hasTabs = Array.isArray(layer.tabs);

      // Case 1: entities-based layer (NO tabs)
      if (!hasTabs) {
        return {
          id: layer.layer_number, // ✅ stable key
          layerName: `Interconnection Layer ${layer.layer_number}`,
          hasTabs: false,
          groups: [
            {
              parent: null,
              shareholders: (layer.entities || []).map((e) => ({
                id: e.id,
                name: e.name,
                type: e.stakeholder_type?.id || '',
                typeName: e.stakeholder_type?.name || '',
                shares: e.percentage_ownership,
                email: e.email,
                userId: e.beneficiary_user_id,
                status: e.user_status,
                needOnboarding: e.need_onboarding,
                errors: {},
              })),
            },
          ],
        };
      }

      // Case 2: tabs-based layer
      return {
        id: layer.layer_number, // ✅ stable key
        layerName: `Interconnection Layer ${layer.layer_number}`,
        hasTabs: true,
        groups: layer.tabs.map((tab) => ({
          parent: {
            id: tab.parent_id,
            name: tab.parent_name,
          },
          shareholders: (tab.group?.beneficiaries || []).map((s) => ({
            id: s.id,
            name: s.name,
            type: s.stakeholder_type?.id || '',
            typeName: s.stakeholder_type?.name || '',
            shares: s.percentage_ownership,
            email: s.email,
            userId: s.beneficiary_user_id,
            status: s.user_status,
            needOnboarding: s.need_onboarding,
            errors: {},
          })),
        })),
      };
    });
  };

  const mapIncomeAssetsToMembers = (apiData = []) => {
    return apiData.map((item) => ({
      revenueType: item?.revenue_type,
      countryType: item?.country,
      assetValue: item?.value,
    }));
  };
  const handleSendReverification = useCallback(
    debounce(async () => {
      let toastMessage = null;
      try {
        const response = await sendReverificationAPI();
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const sendReverificationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agent/customers/review/${customerId}/request-reverification`;
    // ✅ extract only IDs
    const sectionIds = statusData?.map((section) => section.id) || [];

    const bodyData = {
      sections: sectionIds,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}`
          : `/api/v1/agency/customers/review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setCustomerStatus(response.data.open_account_information.status.value);
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setEmail(response.data.open_account_information.email_address.value);
        setMobileNumber(
          response.data.open_account_information.country_code.value +
            response.data.open_account_information.mobile_number.value,
        );
        setCustomerType(
          response.data.open_account_information.account_type.value.name,
        );

        //Trust information
        setAccountTypeLabel(response.data.trust_information.trust_type);
        setCountryType(response.data.trust_information.country_of_established);
        setPreview(response.data.trust_information.trust_logo_url);
        setFullName(response.data.trust_information.trust_full_name);
        setFullSettlorName(response.data.trust_information.settlor_full_name);
        setFormerNames(response.data.trust_information.all_trading_names);
        setRegisteredAddress(
          response.data.trust_information.registered_address,
        );
        setRegistrationNumber(
          response.data.trust_information.registration_number,
        );
        setTrustType(response.data.trust_information.trust_type_category);
        if (
          response.data.trust_information.country_of_established.value.id == 14
        ) {
          setAbn(response.data.trust_information.abn);
        }
        setBusinessActivity(
          response.data.trust_information.business_activities,
        );
        if (response.data.trust_information.business_activities.value.id == 6) {
          setOtherActivity(
            response.data.trust_information.business_activities_description,
          );
        }
        if (response.data.trust_information.income_assets?.length) {
          const mappedMembers = mapIncomeAssetsToMembers(
            response.data.trust_information.income_assets,
          );
          setAssets(mappedMembers);
        }
        //Trustees
        setTrusteeResponse(response.data.trustees_and_beneficiaries);
        //benes
        const uiLayers = mapApiLayersToUiLayers(
          response.data.trustees_and_beneficiaries.beneficiaries.layers,
        );
        setLayers(uiLayers);

        // Upload docs
        setCountryId(
          response.data.trust_information.country_of_established.value.id,
        );
        setCompanycategoryId(
          response.data.trust_information.trust_type.value.id,
        );
        setFileScheme(
          response.data.trust_proof_documents
            .managed_investment_scheme_memorandum,
        );
        setFileRegisteredSubject(
          response.data.trust_proof_documents.regulatory_oversight_document,
        );
        setFileGovFund(
          response.data.trust_proof_documents
            .government_superannuation_document,
        );
        setFileTrustDeed(
          response.data.trust_proof_documents.trust_deed_document,
        );
        setFileExtractDocument(
          response.data.trust_proof_documents
            .regulator_database_search_document,
        );
        setFileProspectusDocument(
          response.data.trust_proof_documents.prospectus_document,
        );
        setFileAccountantCertificate(
          response.data.trust_proof_documents.accountant_certificate_document,
        );
        setFileSelfManagedExtract(
          response.data.trust_proof_documents.smsf_lookup_extract_document,
        );
        setHasAml(
          response.data.trust_proof_documents.satisfies_geographic_link_test,
        );
        setFileProof(response.data.trust_proof_documents.audit_report_document);
        setFileAmlProgram(
          response.data.trust_proof_documents.aml_program_document,
        );
        setSanctionResults(response.data.sanctions_checks);
        setIsDataAvailable(true);
      }
    } catch (err) {
      // setIsDataAvailable(false);
      showToast(err.message, 'error');
    }
  };
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/edd-responses`
          : `/api/v1/agency/customers/review/${customerId}/edd-responses`,
      );
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  function mapGraphToTree(node) {
    if (!node) return null;

    const relationshipType = node.relationship?.type?.toLowerCase() || 'root';

    const relationshipLabel =
      relationshipType === 'shareholder'
        ? 'Shareholder'
        : relationshipType === 'director'
          ? 'Director'
          : relationshipType === 'trustee'
            ? 'Trustee'
            : relationshipType === 'beneficiary'
              ? 'Beneficiary'
              : relationshipType === 'root'
                ? 'Root entity'
                : relationshipType.charAt(0).toUpperCase() +
                  relationshipType.slice(1);

    return {
      name: node.full_name || 'Unknown',

      type:
        node.entity_type === 'corporate'
          ? 'Corporate'
          : node.entity_type === 'trust'
            ? 'Trust'
            : 'Individual',

      // Display label inside node
      relationship: relationshipLabel,

      // Used for role colours
      relationshipKey: relationshipType,

      ownership: node.relationship?.percentage_ownership,

      meta: {
        relationship: relationshipType,
        ownership: node.relationship?.percentage_ownership,
      },

      children: node.children?.map(mapGraphToTree) || [],
    };
  }
  useEffect(() => {
    if (graphData?.graph) {
      const formatted = [mapGraphToTree(graphData.graph)];
      setTreeData(formatted);
    }
  }, [graphData]);
  const getOwnershipgraph = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/${customerId}/ownership-graph`
          : `/api/v1/agency/customers/${customerId}/ownership-graph`,
      );

      if (response.status == 200) {
        setGraphData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    if (customerId) {
      getEddResponses();
      getOwnershipgraph();
    }
  }, [customerId]);
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/sections`
          : `/api/v1/agency/customers/review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data.sections);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getOverallJourney = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/overall-status`
          : `/api/v1/agency/customers/review/${customerId}/overall-status`,
      );
      const stageIconMap = {
        application_submitted: 'description',
        sanction_verification: 'gavel',
        identity_verification: 'verified_user',
        manual_review: 'manage_search',
        approved: 'check_circle',
        rejected: 'cancel',
        resubmission: 'refresh',
      };
      if (response.status == 200) {
        const stages = response.data?.stages || [];

        const mappedStages = stages.map((item) => ({
          ...item,
          key: item.stage,
          icon: stageIconMap[item.stage] || 'circle',
        }));

        setSteps(mappedStages);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
      getOverallJourney();
    }
  }, [customerId, updateFieldStatus]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-[#375AE7] bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          {' '}
          <div className="w-full relative">
            <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
                <span className="font-medium lg:text-lg text-sm">
                  Review KYC
                </span>
              </div>
            </div>
            <div>
              <div className="flex flex-wrap  p-4 justify-between items-center mb-4">
                <div className="flex items-center w-full md:w-auto mb-4 md:mb-0">
                  <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
                    <h1 className="text-md font-medium mr-2">
                      {firstNameSignup} {lastNameSignup}
                    </h1>
                  </div>
                </div>
                <div className="flex space-x-2 w-full md:w-auto">
                  <button
                    onClick={() => {
                      setIsActivityLogOpen(true);
                    }}
                    className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                  >
                    <img
                      src="/backward-10-seconds.svg"
                      alt="Add Icon"
                      className="mr-2"
                    />
                    <span className="inline pr-2">Activity Log</span>
                  </button>
                </div>
              </div>
              {isActivityLogOpen && (
                <ActivityLog
                  onClose={() => setIsActivityLogOpen(false)}
                  customerId={customerId}
                />
              )}
              <div className="w-full  p-4">
                <AuditStepper steps={steps} />
                <div className="w-full mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-6 md:px-7 md:py-7 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
                  <SectionStatusGrid sections={statusData} />
                </div>
              </div>
            </div>
            {isDataAvailable && (
              <>
                {/* Open Account Information */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                    <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/profile-circle-black.svg"
                          alt="User Avatar"
                          className="h-6 w-6 mb-2"
                        />
                        <h1 className="text-md font-medium mb-2">
                          {' '}
                          Open Account Information
                        </h1>
                      </div>
                    </div>
                    {/* Will add popup here */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                      {/* Column 1 */}
                      <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                        <label className="text-sm text-[#A6A6A6]">
                          First Name
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {firstNameSignup}
                        </div>

                        <label className="mt-2 text-sm text-[#A6A6A6]">
                          Last Name
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {lastNameSignup}
                        </div>
                      </div>

                      {/* Column 2 */}
                      <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <label className="text-sm text-[#A6A6A6]">Email</label>
                        <div className="text-sm break-all whitespace-normal max-w-full">
                          {email}
                        </div>

                        <label className="mt-2 text-sm text-[#A6A6A6]">
                          Mobile
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {mobileNumber}
                        </div>
                      </div>

                      {/* Column 3 */}
                      <div className="flex flex-col lg:pt-4 pt-0 px-4">
                        <label className="text-sm text-[#A6A6A6]">
                          Customer Type
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {customerType}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
                {/* Trust Information */}
                <div className="w-full  p-4">
                  <div className="bg-white border rounded-2xl p-4 mt-4">
                    <div className="flex justify-between items-start border-colour-custom px-4">
                      {/* Left Section: Icon + Heading */}
                      <div className="flex items-center space-x-2">
                        <img
                          src="/briefcase.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-xl font-medium">
                          Trust Information
                        </h1>
                      </div>
                      {/* <div className="p-4">
                      <StatusDropdown
                        value={statusData[0]?.status}
                        onChange={(val) => {
                          setLoadingUpdate(true);
                          handleUpdateSection(val, statusData[0].id);
                        }}
                      />
                    </div> */}
                    </div>

                    <div className="bg-white pb-4">
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                        <div className="flex flex-col px-4 pt-4">
                          {preview.value && (
                            <>
                              {' '}
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Trust Logo
                                </label>
                                <StatusButton
                                  status={preview.status}
                                  count={preview.comments?.length}
                                  disabled={true}
                                  openSection={() =>
                                    handleStatusClick(
                                      preview,
                                      'Trust Logo',
                                      preview?.value?.presigned_url,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                                <img
                                  src={preview?.value?.presigned_url}
                                  alt={`${fullName}`}
                                  className="w-20 h-20 rounded-full object-cover"
                                />
                              </div>
                            </>
                          )}
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Select the type of trust
                            </label>
                            <StatusButton
                              status={accountTypeLabel?.status}
                              count={accountTypeLabel?.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  accountTypeLabel,
                                  'Select the type of trust',
                                  accountTypeLabel?.value?.label,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{accountTypeLabel?.value?.label}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Full Name of the Trust
                            </label>
                            <StatusButton
                              status={fullName.status}
                              count={fullName.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  fullName,
                                  'Full Name of the Company',
                                  fullName.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{fullName.value}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              The full name of the settlor of the trust
                            </label>

                            <StatusButton
                              status={fullSettlorName.status}
                              count={fullSettlorName.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  fullSettlorName,
                                  'The full name of the settlor of the trust',
                                  fullSettlorName.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{fullSettlorName.value}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              All business names used by the trust and any other
                              name under which the trust operates
                            </label>
                            <StatusButton
                              status={formerNames.status}
                              count={formerNames.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  formerNames,
                                  'All business names used by the trust and any other name under which the trust operates',
                                  formerNames.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>
                            {Array.isArray(formerNames?.value)
                              ? formerNames.value.join(', ')
                              : ''}
                          </span>
                        </div>
                        <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Select the Type Trust Category
                            </label>
                            <StatusButton
                              status={trustType?.status}
                              count={trustType?.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  trustType,
                                  'Select the Type Trust Category',
                                  trustType?.value?.label,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{trustType?.value?.label}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Country in which the trust was established
                            </label>
                            <StatusButton
                              status={countryType?.status}
                              count={countryType?.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  countryType,
                                  'Country in which the trust was established',
                                  countryType?.value?.name,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{countryType?.value?.name}</span>
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Trust&apos;s Registered Address
                            </label>
                            <StatusButton
                              status={registeredAddress?.status}
                              count={registeredAddress?.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  registeredAddress,
                                  "Trust's Registered Address",
                                  registeredAddress?.value?.google_address,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>
                            {registeredAddress?.value?.google_address}
                          </span>
                        </div>
                        <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                          {countryType?.value?.id == 14 && (
                            <>
                              {' '}
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  ABN
                                </label>
                                <StatusButton
                                  status={abn?.status}
                                  count={abn?.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      abn,
                                      'ABN',
                                      abn?.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{abn?.value}</span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                        <div className="flex flex-col px-4 pt-4">
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Registration Number
                            </label>
                            <StatusButton
                              status={registrationNumber?.status}
                              count={registrationNumber?.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  registrationNumber,
                                  'Registration Number',
                                  registrationNumber?.value?.google_address,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{registrationNumber?.value}</span>
                        </div>
                        <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4"></div>
                        <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Business Activity
                            </label>
                            <StatusButton
                              status={businessActivity.status}
                              count={businessActivity.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  businessActivity,
                                  'Business Activity',
                                  businessActivity?.value?.label,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{businessActivity?.value?.label}</span>
                          {businessActivity?.value?.id == 6 && (
                            <>
                              <div className="flex mt-2 items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Other Activity
                                </label>
                                <StatusButton
                                  status={otherActivity.status}
                                  count={otherActivity.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      otherActivity,
                                      'Other Activity',
                                      otherActivity.value,
                                      '',
                                    )
                                  }
                                />
                              </div>
                              <span>{otherActivity.value}</span>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center border-b border-colour-custom space-x-2 px-4 mt-4">
                        <h1 className="text-xl font-medium mb-2">
                          Income and assets (including location) of the trust
                        </h1>
                      </div>
                      <div className="overflow-x-auto">
                        <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                          {/* Table Head */}
                          <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                            <tr>
                              <th className="p-2 w-[40px]"></th>
                              <th className="p-2">Type of Revenue</th>
                              <th className="p-2">Location</th>
                              <th className="p-2">Value of asset or income</th>
                              <th className="p-2 w-[40px]"></th>
                            </tr>
                          </thead>

                          {/* Table Body */}
                          <tbody>
                            {assets.map((member, idx) => (
                              <tr
                                key={idx}
                                className="border-t bg-white align-top"
                              >
                                {/* Index */}
                                <td className="px-4 py-4 font-medium text-gray-600">
                                  {(idx + 1).toString().padStart(2, '0')}.
                                </td>
                                <td className="px-4 py-4">
                                  <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">
                                    <span className="text-ellipsis overflow-hidden whitespace-nowrap">
                                      {member.revenueType?.value?.label}
                                    </span>

                                    <StatusButton
                                      status={member.revenueType?.status}
                                      count={
                                        member.revenueType?.comments?.length
                                      }
                                      openSection={() =>
                                        handleStatusClick(
                                          member.revenueType,
                                          'Type of Revenue',
                                          member.revenueType?.value?.label,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                </td>

                                <td className="px-4 py-4">
                                  <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">
                                    <span className="text-ellipsis overflow-hidden whitespace-nowrap">
                                      {member.countryType?.value?.name}
                                    </span>

                                    <StatusButton
                                      status={member.countryType?.status}
                                      count={
                                        member.countryType?.comments?.length
                                      }
                                      openSection={() =>
                                        handleStatusClick(
                                          member.countryType,
                                          'Location',
                                          member.countryType?.value?.name,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                </td>

                                <td className="px-4 py-4">
                                  <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">
                                    <span className="text-ellipsis overflow-hidden whitespace-nowrap">
                                      {member.assetValue?.value
                                        ? new Intl.NumberFormat('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(
                                            Number(member.assetValue?.value),
                                          )
                                        : ''}
                                    </span>

                                    <StatusButton
                                      status={member.assetValue?.status}
                                      count={
                                        member.assetValue?.comments?.length
                                      }
                                      openSection={() =>
                                        handleStatusClick(
                                          member.assetValue,
                                          'Value of asset or income',
                                          member.assetValue?.value,
                                          '',
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
                {/* Shareholders and directors section */}
                <div className="w-full  p-4">
                  <div className="bg-white mt-4 border rounded-2xl p-4">
                    <div className="border-b">
                      <TrusteesPanel
                        trusteeResponse={trusteeResponse}
                        isEdit={false}
                        isShareholder={false}
                        customerId={customerId}
                        trusteeName={firstNameSignup + ' ' + lastNameSignup}
                      />
                    </div>
                    <div className="bg-white  rounded-2xl mt-4">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-2 md:space-y-0 px-2">
                        <div className="flex items-center space-x-2">
                          <img
                            src="/people.svg"
                            alt="User Avatar"
                            className="h-6 w-6"
                          />
                          <h1 className="text-xl font-medium">
                            Unit Holders/Beneficiaries:
                            <span className="text-xl font-medium text-[#8C8C8C] ml-1">
                              {firstNameSignup} {lastNameSignup}
                            </span>
                          </h1>
                        </div>
                        {/* <div className="p-4">
                        <StatusDropdown
                          value={statusData[1]?.status}
                          onChange={(val) => {
                            setLoadingUpdate(true);
                            handleUpdateSection(val, statusData[1].id);
                          }}
                        />
                      </div> */}
                        <div className="flex space-x-2">
                          <button
                            onClick={() => {
                              setShowVisualLink(true);
                            }}
                            className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                          >
                            <img
                              src="/hashtag.svg"
                              alt="Collapse Icon"
                              className="w-4 h-4 flex-shrink-0"
                            />
                            <span className="font-medium">Visual Link</span>
                          </button>
                          <button
                            onClick={handleCollapseAll}
                            className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                          >
                            <img
                              src="/arrow-square-up.svg"
                              alt="Collapse Icon"
                              className="w-4 h-4 flex-shrink-0"
                            />
                            <span className="font-medium">Collapse All</span>
                          </button>
                          <button
                            onClick={handleExpandAll}
                            className="bg-[#375AE7] text-white text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                          >
                            <img
                              src="/arrow-square-down.svg"
                              alt="Collapse Icon"
                              className="w-4 h-4 flex-shrink-0"
                            />
                            <span className="font-medium">Expand All</span>
                          </button>
                        </div>
                      </div>
                      {showVisualLink && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
                          <div className="relative bg-white  w-[95%] md:w-[900px] p-6">
                            {/* Close Button */}
                            <button
                              onClick={() => setShowVisualLink(false)}
                              className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl font-bold transition-colors"
                            >
                              &times;
                            </button>

                            {/* Graph */}
                            <div className="mt-6 w-full h-[500px] overflow-hidden">
                              <MindmapTree data={treeData} />
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="pt-2">
                        {layers.map((layer) => (
                          <ShareholderLayer
                            key={layer.id}
                            layer={layer}
                            collapsed={collapsedLayers[layer.id] ?? false}
                            onToggle={() =>
                              setCollapsedLayers((prev) => ({
                                ...prev,
                                [layer.id]: !prev[layer.id],
                              }))
                            }
                          />
                        ))}
                      </div>
                    </div>
                  </div>{' '}
                </div>
                {/* Upload Proof Documents */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                    <div className="flex flex-wrap md:flex-nowrap items-center justify-between border-colour-custom pt-2 px-4 gap-4">
                      {/* Left Section (Title + Icon) */}
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/note-2.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-md font-medium">
                          Upload Proof Documents
                        </h1>
                      </div>
                      {/* <div className="p-4">
                        <StatusDropdown
                          value={statusData[2]?.status}
                          onChange={(val) => {
                            setLoadingUpdate(true);
                            handleUpdateSection(val, statusData[2].id);
                          }}
                        />
                      </div> */}
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 pb-2">
                      {/* first column */}
                      <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                        {companycategoryId == 1 && (
                          <>
                            <div className="">
                              <FileUploadDisplay
                                label="A managed investment scheme that is not registered by Regulator in your specific country and that only has wholesale clients and does not make small scale offerings Memorandum"
                                fileData={fileScheme}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Registered and subject to the regulatory oversight of a regulator in relation to its activities as a trust"
                                fileData={fileRegisteredSubject}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        {countryId == 14 && companycategoryId != 1 && (
                          <div className="">
                            <FileUploadDisplay
                              label="Accountant Certificate"
                              fileData={fileAccountantCertificate}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                      {/* second column */}
                      <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                        {companycategoryId == 1 && (
                          <>
                            <div className="">
                              <FileUploadDisplay
                                label="A government superannuation fund established by legislation."
                                fileData={fileGovFund}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="mt-2">
                              <FileUploadDisplay
                                label="Trust Deed"
                                fileData={fileTrustDeed}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        {(companycategoryId == 3 ||
                          (companycategoryId == 2 && countryId == 14)) && (
                          <FileUploadDisplay
                            label="A managed investment scheme registered by ASIC - Upload Prospectus Document"
                            fileData={fileProspectusDocument}
                            onFileClick={handleFileClick}
                          />
                        )}
                        {companycategoryId == 2 && countryId != 14 && (
                          <FileUploadDisplay
                            label="Self-Managed Super Fund Lookup Extract"
                            fileData={fileSelfManagedExtract}
                            onFileClick={handleFileClick}
                          />
                        )}
                      </div>
                      {/* third column */}
                      <div className="flex flex-col pr-4 pt-4">
                        {(companycategoryId == 1 ||
                          (companycategoryId == 2 && countryId != 14)) && (
                          <>
                            <FileUploadDisplay
                              label="A search of the relevant ASIC, APRA or other regulator database"
                              fileData={fileExtractDocument}
                              onFileClick={handleFileClick}
                            />
                          </>
                        )}
                        {companycategoryId == 1 && (
                          <div className="mt-2">
                            <FileUploadDisplay
                              label="A managed investment scheme registered by ASIC - Upload Prospectus Document"
                              fileData={fileProspectusDocument}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                        {companycategoryId == 3 && countryId != 14 && (
                          <>
                            <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                              <label
                                htmlFor="investmentType"
                                className="[#A6A6A6] block whitespace-normal break-words text-sm text-[#A6A6A6] flex items-center"
                              >
                                Do you satisfy one of the geographical link
                                tests in ss 6(6) of the AML/CTF Act or that its
                                name and enrolment details are entered on the
                                Reporting Entities Roll; and that it has carried
                                out all applicable KYC and ongoing customer due
                                diligence requirements in accordance with
                                Chapter 15 of the AML/CTF Rules in relation to
                                its underlying customers, prior to, or at the
                                time of becoming a customer of Ratified.
                              </label>
                              <div className="flex items-center gap-4 opacity-50 ">
                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="hasLicense"
                                    value={true}
                                    checked={hasAml === true}
                                    disabled={true}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#375AE7]"
                                  />
                                  <span className="ml-2">Yes</span>
                                </label>
                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="hasLicense"
                                    value={false}
                                    checked={hasAml === false}
                                    disabled={false}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#375AE7]"
                                  />
                                  <span className="ml-2">No</span>
                                </label>
                              </div>
                              {hasAml && (
                                <>
                                  <div className="mt-4">
                                    <FileUploadDisplay
                                      label="Audit Report (Most Recent)"
                                      fileData={fileProof}
                                      onFileClick={handleFileClick}
                                    />
                                  </div>
                                  <div className="mt-4">
                                    <FileUploadDisplay
                                      label="AML Program"
                                      fileData={fileAmlProgram}
                                      onFileClick={handleFileClick}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {countryId == 14 && companycategoryId == 1 && (
                          <div className="mt-4">
                            <FileUploadDisplay
                              label="Accountant Certificate"
                              fileData={fileAccountantCertificate}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
                <div className="w-full  p-4">
                  <div className="bg-gradient-to-br from-gray-50 via-white to-gray-100 p-5 mt-4 rounded-2xl border space-y-6">
                    {/* HEADER */}
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                      <div>
                        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                          👤{' '}
                          <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                            {fullNameSanction}
                          </span>
                        </h2>
                        <p className="text-xs text-gray-500">
                          Full Screening Overview
                        </p>
                      </div>
                      {/* <div className="p-4">
                      <button
                        onClick={() => setShowModal(true)}
                        className="ml-3 bg-[#375AE7] text-sm text-white px-4 py-2 rounded-lg hover:bg-[#2f4ed8] transition"
                      >
                        Start ECDD Check
                      </button>
                    </div> */}
                    </div>

                    {/* SCORE + SUMMARY */}
                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="bg-white/80 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                        <p className="text-xs text-gray-500 flex items-center gap-1">
                          📅 Last Screening
                        </p>
                        <h2 className="text-lg font-semibold text-gray-800">
                          {screeningDate}
                        </h2>
                        <p className="text-xs text-gray-400">
                          Auto-updated in real time
                        </p>
                      </div>

                      <div className="bg-white/80 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                        <p className="text-xs text-gray-500 flex items-center gap-1">
                          🛡️ Compliance Status
                        </p>
                        <h2
                          className={`text-lg font-semibold ${compliance.color}`}
                        >
                          {compliance.label}
                        </h2>
                        <p className="text-xs text-gray-400">
                          {compliance.sub}
                        </p>
                      </div>
                    </div>

                    {/* CHECKS GRID */}
                    <div className="grid md:grid-cols-3 gap-4">
                      <div className="hover:scale-[1.02] transition">
                        <CheckItem
                          label="Sanctions Screening"
                          status={sanctionsStatus}
                        />
                      </div>
                      <div className="hover:scale-[1.02] transition">
                        <CheckItem label="PEP Check" status={pepStatus} />
                      </div>
                      <div className="hover:scale-[1.02] transition">
                        <CheckItem
                          label="Adverse Media"
                          status={adverseStatus}
                        />
                      </div>
                    </div>

                    {/* SOURCES SECTION */}
                    <div className="bg-white/90 backdrop-blur p-5 rounded-2xl border shadow-sm space-y-6">
                      {/* Checked Sources */}
                      <div>
                        <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                          🔍 Sources Checked
                          <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-200">
                            {sourcesChecked.length}
                          </span>
                        </h3>
                        <div className="flex flex-wrap gap-2">
                          {sourcesChecked.length > 0 ? (
                            sourcesChecked.map((source, index) => {
                              const isMatched = matchedSources.includes(source);

                              return (
                                <span
                                  key={index}
                                  className={`px-3 py-1 text-xs rounded-full border flex items-center gap-1 transition-all duration-200 hover:scale-105 ${getSourceStyle(
                                    source,
                                    isMatched,
                                  )}`}
                                >
                                  {isMatched ? '⚠️' : '✔️'}

                                  {formatSourceName(source)}

                                  {isMatched && (
                                    <span className="ml-1 text-[10px] font-medium">
                                      (Match)
                                    </span>
                                  )}
                                </span>
                              );
                            })
                          ) : (
                            <p className="text-xs text-gray-400">
                              No sources available
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Matched Sources */}
                      <div>
                        <h3 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                          🎯 Matched Sources
                        </h3>

                        {matchedSources.length > 0 ? (
                          <div className="flex flex-wrap gap-2">
                            {matchedSources.map((source, index) => (
                              <span
                                key={index}
                                className="px-3 py-1 text-xs rounded-full border flex items-center gap-1 bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200 shadow-sm hover:scale-105 transition"
                              >
                                ⚠️ {source}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <div className="flex items-center gap-2 text-xs text-green-700 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 px-3 py-2 rounded-lg">
                            ✅ No matches found across all screened sources
                          </div>
                        )}
                      </div>
                    </div>

                    {/* INSIGHT PANEL */}
                    <div className="bg-white/90 backdrop-blur p-4 rounded-2xl border shadow-sm hover:shadow-md transition">
                      <h3 className="text-sm font-semibold text-gray-800 mb-2 flex items-center gap-2">
                        🧠 Compliance Insight Summary
                      </h3>

                      <p className="text-xs text-gray-600 leading-relaxed">
                        {uiSummary || 'No summary available'}
                      </p>
                    </div>
                  </div>
                </div>
                {(pendingQuestions.length > 0 ||
                  completedGroups.length > 0) && (
                  <div className="bg-white rounded-2xl p-4">
                    <div className="bg-white border rounded-2xl p-4 mt-4">
                      {pendingQuestions.length > 0 && (
                        <div className="w-full p-4">
                          <UserQuestionnaire
                            apidata={pendingQuestions}
                            customerName={
                              firstNameSignup + ' ' + lastNameSignup
                            }
                            isPending={true}
                            heading={'Customer Submitted ECDD Responses'}
                          />
                        </div>
                      )}
                      {completedGroups.length > 0 && (
                        <div className="w-full p-4">
                          <UserQuestionnaire
                            apidata={completedGroups}
                            customerName={
                              firstNameSignup + ' ' + lastNameSignup
                            }
                            isPending={false}
                            heading={'Customer Submitted ECDD Responses'}
                          />
                        </div>
                      )}{' '}
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="flex items-center mt-6 p-4 bg-[#375AE7]">
              {/* Right Section: Download Button */}
              <div className="flex items-center justify-end w-full">
                {customerStatus != 'active' && (
                  <div ref={dropdownRef} className="relative inline-block mr-4">
                    {/* Button */}
                    <div
                      className="flex text-sm justify-between items-center py-2 px-2 border border-white  w-40 rounded-full cursor-pointer"
                      onClick={() => setIsOpenAction(!isOpenAction)}
                    >
                      <span className="text-right pl-4 text-white">
                        Actions
                      </span>
                      <span className="text-gray-500">
                        {' '}
                        <img
                          src="/white-dropdown.svg"
                          alt="document-download"
                          className="pr-2"
                        />
                      </span>
                    </div>

                    {/* Dropdown Menu */}
                    {isOpenAction && (
                      <div className="absolute text-xs top-[-250%] right-0 bg-white text-black shadow-lg rounded-md w-40 p-2 z-10">
                        <ul>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'approve');
                            }}
                            className="p-2 hover:bg-[#375AE7] hover:text-white cursor-pointer"
                          >
                            Approve Application
                          </li>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'reject');
                            }}
                            className="p-2 hover:bg-[#375AE7] text-[#FF5050] hover:text-[#FF5050] cursor-pointer"
                          >
                            Reject Application
                          </li>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'resubmit');
                            }}
                            className="p-2 hover:bg-[#375AE7] text-[#FF5050] hover:text-[#FF5050] cursor-pointer"
                          >
                            Send for resubmit
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                )}

                {customerStatus == 'active' && (
                  <div ref={dropdownRef} className="relative inline-block mr-4">
                    {/* Button */}
                    <div
                      className="flex text-sm border border-white py-2 w-40 rounded-full cursor-pointer"
                      onClick={() => {
                        setLoadingUpdate(true);
                        handleSendReverification();
                      }}
                    >
                      <span className="text-right pl-4 text-white">
                        Send for resubmit
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={currentDocument.presigned_url}
                fileName={currentDocument.file_name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
            {showModal && (
              <EDDModal
                pendingQuestions={pendingQuestions}
                completedQuestions={completedQuestions}
                closeModal={() => {
                  setShowModal(false);
                  getEddResponses();
                }}
              />
            )}
            {showPopup && currentField && (
              <ReviewPopupKYC
                isOpen={showPopup}
                currentField={currentField}
                currentFieldName={currentFieldName}
                currentFieldValue={currentFieldValue}
                currentFieldType={currentFieldType}
                onClose={() => setShowPopup(false)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
const CheckItem = ({ label, status }) => {
  const styles = {
    completed: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    found: 'bg-red-50 text-red-700 border-red-100',
    warn: 'bg-amber-50 text-amber-700 border-amber-100',
  };

  const icons = {
    completed: '✔',
    found: '✖',
    warn: '⚠',
  };
  return (
    <div
      className={`flex justify-between items-center p-3 rounded-xl border shadow-sm ${styles[status]} transition hover:shadow-md`}
    >
      <span className="text-xs font-medium text-gray-800">{label}</span>

      <span className="text-xs font-semibold flex items-center gap-1">
        {icons[status]} {status.toUpperCase()}
      </span>
    </div>
  );
};
const ShareholderLayer = ({ layer, collapsed, onToggle }) => {
  const { layerName, groups, hasTabs } = layer;
  const isOpen = !collapsed;
  const navigate = useNavigate();
  const location = useLocation();
  const { customerId } = useParams();

  const [activeTab, setActiveTab] = useState(0);
  const rowsToRender = hasTabs
    ? groups[activeTab]?.shareholders || []
    : groups[0]?.shareholders || [];

  useEffect(() => {
    setActiveTab(0);
  }, [groups]);

  return (
    <div className="border rounded-2xl shadow-sm bg-white mb-6">
      {/* Header */}
      <div
        onClick={onToggle}
        className="bg-[#464646] text-white px-4 py-2 rounded-t-2xl flex justify-between items-center cursor-pointer"
      >
        <h2 className="text-sm font-medium">{layerName}</h2>
        <span className="text-lg">{isOpen ? '−' : '+'}</span>
      </div>

      {isOpen && (
        <>
          {/* Tabs ONLY when groups > 1 */}
          {hasTabs && (
            <div className="flex border-b">
              {groups.map((g, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`px-4 py-2 text-sm font-medium ${
                    activeTab === idx
                      ? 'bg-[#375AE7] text-white'
                      : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  {g.parent?.name}
                </button>
              ))}
            </div>
          )}

          {/* Table */}
          <div className="p-4 border rounded-b-lg">
            <div className="overflow-x-auto">
              <table className="w-full text-sm  text-[#8C8C8C]">
                <thead>
                  <tr className="border">
                    <th className="p-2"></th>
                    <th className="p-2 text-left font-medium">
                      Shareholder Name
                    </th>
                    <th className="p-2 text-left font-medium">Type</th>
                    <th className="p-2 text-left font-medium">Shares(%)</th>
                    <th className="p-2 text-left font-medium">Email</th>
                    <th className="p-2 text-left font-medium">
                      User Registration
                    </th>
                    <th className="p-2 text-left font-medium">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {rowsToRender.map((s, idx) => (
                    <tr key={s.id} className="border-t font-medium text-black">
                      <td className="p-2 text-[#8C8C8C]">
                        {String(idx + 1).padStart(2, '0')}.
                      </td>
                      <td className="p-2">{s.name}</td>
                      <td className="p-2">{s.typeName}</td>
                      <td className="p-2">{s.shares}</td>
                      <td className="p-2">{s.email}</td>
                      <td className="p-2">
                        {s.shares >= 25 && s.needOnboarding ? (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              let redirectState = {
                                path:
                                  s.type == 1
                                    ? `/review-kyc-jointaccount/${s.userId}`
                                    : s.type == 2
                                      ? `/review-kyc-corporate-shareholder/${s.userId}`
                                      : `/review-kyc-trust-shareholder/${s.userId}/${customerId}`,
                                state: {
                                  from: location.pathname,
                                  historyStack: [
                                    ...(location.state?.historyStack || []),
                                    location.pathname,
                                  ],
                                },
                              };
                              sessionStorage.setItem(
                                'redirectAfterLogin',
                                JSON.stringify(redirectState),
                              );
                              navigate(
                                s.type == 1
                                  ? `/review-kyc-jointaccount/${s.userId}`
                                  : s.type == 2
                                    ? `/review-kyc-corporate-shareholder/${s.userId}`
                                    : `/review-kyc-trust-shareholder/${s.userId}/${customerId}`,
                                {
                                  state: {
                                    from: location.pathname,
                                    historyStack: [
                                      ...(location.state?.historyStack || []),
                                      location.pathname,
                                    ],
                                  },
                                },
                              );
                            }}
                            className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium"
                          >
                            View Application
                          </button>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>
                      <td className="p-2 font-medium">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-semibold inline-block
      ${
        s.status === 'pending' || s.status === 'onboarding'
          ? 'bg-yellow-100 text-yellow-800'
          : s.status === 'to_review'
            ? 'bg-blue-100 text-blue-800'
            : s.status === 'approved' || s.status === 'active'
              ? 'bg-green-100 text-green-800'
              : 'bg-gray-100 text-gray-700'
      }
    `}
                        >
                          {s.status
                            ?.replaceAll('_', ' ')
                            ?.replace(/\b\w/g, (c) => c.toUpperCase())}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ReviewKYCTrust;
